import lodashKebabCase from 'lodash/kebabCase';

export default function addressSlugger(address) {
    return lodashKebabCase(address || '');
}
